import {
  integration_get_entity_accessors_path,
  integration_list_path,
  integration_trigger_queue_mark_confirmed_path
} from '~/routes'

export const Integration = {
    list: function() {
      ActionJS.Integration.priv.initEntityTable();
      ActionJS.Integration.priv.initEndpointTable();
      ActionJS.Integration.priv.initTriggerQueueTable();
      if (window.location.hash.length > 1 && document.querySelector(window.location.hash)) {
        // Race condition fix. Wait for the tables to be rendered...
        window.setTimeout(function(){
          document.querySelector(window.location.hash).scrollIntoView()
        }, 200)
      }
    },

    form_editor_load_external_entity_linking: function(object_type, options) {
      var options = typeof options !== 'undefined' ? options : {};
      var route = integration_get_entity_accessors_path({object_type: object_type, options: options});
      return new Promise(function(resolve){
        var cachedItem = ActionJS.Integration.priv.externalEntityCache[route];
        if (cachedItem){
          resolve(cachedItem);
          return
        }
        jQuery.get(integration_get_entity_accessors_path({object_type: object_type, options: options}), function(res) { 
          ActionJS.Integration.priv.externalEntityCache[route] = res.options
          resolve(res.options);          
        })
      })
    },

    sync: function() {
      jQuery('#sync').on('click', function(){
        $(this).html(I18n.t('loading')).attr('disabled', true);
        jQuery.post($(this).attr('data-action'), function(res) {
          if (res.error) {
            $('#sync-result').append($('<div>').html(res.error).addClass('alert alert-danger'));
          }
          else if (res.changes.length) {
            var syncMessage = I18n.t('successfull_sync')
            if (res.triggers_fired_count > 0) {
              syncMessage += ' ' + I18n.t('triggers_fired', {count: res.triggers_fired_count}) + ' '
              syncMessage += '</br><b>'
              syncMessage += $('<a/>').attr('href', integration_list_path() + '#triggers').html(I18n.t('confirm_the_function_calls')).get(0).outerHTML;
              syncMessage += '</br></b>'
            }
            $('#sync-result').append($('<div>').html(syncMessage).addClass('alert alert-success'));
            $('#sync-result').append($('<h2>').html(I18n.t('changes')));

            res.changes.forEach(function(element){
              var template = jQuery('#sync-result-template').html();
              template = template
                .replace('__CREATED_AT_LEFT__', element.type == 'create' ? '-' : element.old.updated_at)
                .replace('__BODY_LEFT__', element.type == 'create' ? '{}' : syntaxHighlight(JSON.stringify(sortObject(element.old.body), undefined, 4)))
                .replace('__CREATED_AT_RIGHT__', element.new.updated_at)
                .replace('__BODY_RIGHT__', syntaxHighlight(JSON.stringify(sortObject(element.new.body), undefined, 4)));
              jQuery('#sync-result').append(template);
            });
  
          } else {
            $('#sync-result').append($('<div>').html(I18n.t('already_up_to_date')).addClass('alert alert-success'));
          }
          $(this).hide();
        }.bind(this))
      });
    },

    priv: {
      externalEntityCache: {},

      initEndpointTable: function(){
        var options = {
          bDeferRender: true,
          data: JSON.parse(jQuery('#endpoint-list-data').html()),
          info: false,
          lengthChange: false,
          pageLength: 20,
          searching: false,

          autoWidth: false,
          columnDefs: [
            {
              targets: [2],
              searchable: false,
              sortable: false
            }
          ],
          drawCallback: function () {
            // DataTablesHelper.addColumnFilters(this);
          },
          footerCallback: function () {
            DataTablesHelper.togglePagination(this);
          }
        };
    
        var formTable = jQuery('#endpoint-table');
        var table = formTable.DataTable(options);
      },

      initEntityTable: function(){
        var options = {
          bDestroy: true,
          bDeferRender: true,
          data: JSON.parse(jQuery('#entity-list-data').html()),
          info: false,
          lengthChange: false,
          pageLength: 20,
          autoWidth: false,
          searching: false,

          columnDefs: [
            {
              targets: [2],
              searchable: false,
              sortable: false
            }
          ],
          drawCallback: function () {
            // DataTablesHelper.addColumnFilters(this);
            ActionJS.Integration.priv.bindEvent();
          },
          footerCallback: function () {
            DataTablesHelper.togglePagination(this);
          }
        };
    
        var formTable = jQuery('#integration-table');
        formTable.DataTable(options);
    
      },
      
      initTriggerQueueTable: function() {
        var options = {
          bDeferRender: true,
          data: JSON.parse(jQuery('#trigger-event-list-data').html()),
          info: false,
          lengthChange: false,
          pageLength: 20,
          autoWidth: false,
          searching: false,
          sorting: false,
          columnDefs: [
            {
              targets: "_all",
              sortable: false,
            },
            {
              targets: [0],
              searchable: false,
              sortable: false,
              render: function(data,type,rowData) {
                return jQuery('<input/>')
                  .attr('type','checkbox')
                  .attr('value', data.id)
                  .attr('name', 'confirmed_until_id')
                  .attr('disabled', data.confirmed)
                  .attr('title', data.confirmed ? I18n.t('already_confirmed_call') : '')
                  .get(0).outerHTML;
              }
            }
          ],
          drawCallback: function(){
            $('#trigger-event-table input[type="checkbox"]').on('click', ActionJS.Integration.priv._selectQueueItemsUpTo);
          },
          footerCallback: function () {
            DataTablesHelper.togglePagination(this);
          }
        };
    
        var formTable = jQuery('#trigger-event-table');
        var table = formTable.DataTable(options);
  
        jQuery('#confirm-function-calls').on('click', function(e){
          var lastCheckedId = jQuery('input[type="checkbox"]:checked').last().val();
          jQuery.post(integration_trigger_queue_mark_confirmed_path({confirmed_until_id: lastCheckedId}),
          function() {
            Turbo.visit(location.href, {action: 'replace'});
          })
        });
      },
  
      _selectQueueItemsUpTo: function(e){
        var tableBody = $(e.target).closest('tbody');
        var selectedUntil = false;
        var checkBoxes = tableBody.find('input[type="checkbox"]');
        checkBoxes.prop('checked', false); // Uncheck all
        // Check until the clicked
        tableBody.find('input[type="checkbox"]').each(function(){
          if (!selectedUntil){
            $(this).prop('checked', true);
            if ($(this).val() == $(e.target).val()) {
              selectedUntil = true;
            }
          }
        })
        jQuery('#confirm-function-calls').attr('disabled', false);
      },

      bindEvent: function(){
        jQuery('.form-clone-link, .form-delete-link').off('click').on('click', function(e){
          e.stopPropagation();
          var c = true;
          if (jQuery(this).data('confirm')){
            c = confirm(jQuery(this).data('confirm'));
          } 
          if (c) {
            jQuery.ajax({
              url: jQuery(this).attr('href'),
              method: 'POST',
              headers: {"X-CSRF-Token": jQuery('meta[name="csrf-token"]').attr('content')},
            }).done(function(d){

              Turbo.visit(location.href, {action: 'replace'});
            });
          }
          e.preventDefault();
        });
      }
    }
};